import React, {useState} from "react";
import LoadingButton from 'Components/LoadingButton';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import deleteIcon from "Assets/Icons/delete.svg";
import useVipApiFetcher, { handleError, handleResponse, handleOkResponse } from "Utils/Hooks/useVipApiFetcher";
import { endingIn } from 'Utils/Utils';
import { Routes } from 'Utils/Constants';
import { useHistory } from "react-router-dom";
import useMode, { MODE } from "Utils/Hooks/useMode";
import useFundType, { FUNDTYPE } from "Utils/Hooks/useFundType";
import { faro } from "@grafana/faro-react";

const DeleteAccountButton = ({account, bankAccountData}) => {

  const fundType = useFundType();
  const vipApi = useVipApiFetcher();
  const history = useHistory();
  const [submitted, setSubmitted] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleClose = () => setShowConfirmation(false);
  const handleShow = () => {
    setShowConfirmation(true);
    faro.api.pushEvent("User clicked delete Funding Source icon");
  }

  const mode = useMode();
  const isDepositMode = mode === MODE.deposit;

  const onDeleteBank = async () => {
    setSubmitted(true);
    const body = {
      bankName: account.bankName,
      routingNumber: account.routingNumber,
      accountNumber: account.accountNumber,
      maskedAccountNumber: account.maskedAccountNumber,
      netspendCardReferenceNumber: account.netspendCardReferenceNumber
    };

    vipApi.fetch("/api/bank", "DELETE", body)
      .then(response => handleResponse(history, response))
      .then(response =>
        handleOkResponse({
          history,
          response,
          title: fundType === FUNDTYPE.netspend ?  "Netspend/Playcard Account Deleted" : "Bank Account Deleted",
          message: `Your ${response.body.bankName} account${endingIn(account.accountNumberDisplay)} has been successfully deleted.`,
          customButtons: true ? [{
            label: 'ADD NEW FUNDING SOURCE',
            route: Routes.ADD_ACCOUNT,
            notRedirect : true
          },{
            label: `COMPLETE ${(isDepositMode) ? 'DEPOSIT' : 'WITHDRAW'}`,
            route: (isDepositMode) ? Routes.DEPOSIT : Routes.WITHDRAW,
            notRedirect : true
          }] : undefined,
          errorCustomButtons: true ? [{
            label: 'TRY AGAIN',
            route: Routes.MY_ACCOUNTS
          },{
            label: `COMPLETE ${(isDepositMode) ? 'DEPOSIT' : 'WITHDRAW'}`,
            route: (isDepositMode) ? Routes.DEPOSIT : Routes.WITHDRAW,
          }] : undefined,
        })
      )
      .catch(error => {
        faro.api.pushError(new Error("Delete Account Network Error"), { context: error });
        handleError(error, history);
      });
      faro.api.pushEvent("User confirms to delete Funding Source");
  }

  const minLimitReached = (bankAccountData?.length === 1);
  const title = minLimitReached ? "Minimum Account Limit" : "Delete Account";
  const bodyText = minLimitReached ? "At least one bank account is required. Please add a new bank account before removing this one." : <>Are you sure you want to delete your {account.bankName?.toUpperCase()} account{endingIn(account.accountNumberDisplay)}?</>;
  const buttons = minLimitReached ? 
          <Row>
            <Col>
              <button className="submit-button click-delete-confirm-ok" onClick={handleClose}>
                OK
              </button>
            </Col>
          </Row> :
          <><Row>
            <Col>
            {(submitted) ?
              <LoadingButton /> :
              <button className="submit-button click-delete-confirm-yes" onClick={onDeleteBank}>
                YES
              </button>}
            </Col>
          </Row>
          <Row>
            <Col>
              <button className="submit-button click-delete-confirm-cancel" onClick={handleClose}>
                CANCEL
              </button>
            </Col>
          </Row></>;

  return (
    <>
      <button
        onClick={handleShow}
        className="delete click-delete">
        <img alt="Delete Account" src={deleteIcon} className="click-delete" />
      </button>
      <Modal
        show={showConfirmation}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="transaction-confirmation"
        animation={false}
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Container>
              <Row>
                <Col className="modal-title">
                  {title}
                </Col>
              </Row>
              <Row>
                <Col className="text-center bank-text">
                  {bodyText}
                </Col>
              </Row>
              {buttons}      
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DeleteAccountButton;